var map = {
	"./admin.js": "653e",
	"./cooperation.js": "4a1c",
	"./course.js": "2db5",
	"./news.js": "3d09",
	"./recruitment.js": "45ee",
	"./staff.js": "fb02",
	"./upload.js": "d1db",
	"./user.js": "8bfb",
	"./webConfig.js": "53e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b93";